<div class="header-container">
  <h3 class="header">Pre-orders for Today</h3>

  <ion-button class="close-btn" fill="clear" (click)="close(false)">
    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
  </ion-button>
</div>

<p class="context" [innerHTML]="context"></p>

<div class="alert-buttons">
  <ion-button (click)="close(false)" fill="outline" shape="round" size="large"> Dismiss </ion-button>

  <ion-button class="print-all" (click)="close(true)" color="primary" shape="round" size="large">
    Print All
  </ion-button>
</div>
